import { useOutletContext } from "react-router";

import {
  EmptystateDataFlowColored,
  EmptystateSearchNoResultsColored,
} from "components/icons/generated";
import { Spinner } from "components/Spinner";
import EmptyState from "ds/components/EmptyState";
import { isScanRunInProgress } from "shared/Scan/access/useCanTriggerScan";

import { ScanResourcesOutletContext } from "../../types";

type ScanResourcesEmptyStateProps = {
  hasNoResults?: boolean;
};

const ScanResourcesEmptyState = ({ hasNoResults }: ScanResourcesEmptyStateProps) => {
  const { run } = useOutletContext<ScanResourcesOutletContext>();
  const isScanInProgress = isScanRunInProgress(run?.state);

  if (hasNoResults) {
    return (
      <EmptyState
        title="No results"
        caption="Don't give up! Check the spelling or try something less specific."
        icon={EmptystateSearchNoResultsColored}
        fullHeight
        announce
      />
    );
  }

  if (isScanInProgress) {
    return (
      <EmptyState
        title="Scan in progress"
        caption="Resources will show up here as soon as this run finishes discovering them."
        icon={Spinner}
        fullHeight
        announce
      />
    );
  }

  return (
    <EmptyState
      title="No resources discovered"
      caption="This scan hasn't recorded any resources yet. Once it runs, everything it finds shows up here."
      icon={EmptystateDataFlowColored}
      fullHeight
      announce
    />
  );
};

export default ScanResourcesEmptyState;
